<template>
  <widget-template title="To Do List" subTitle="Reminder for your tasks" :padded="false">
    <template slot="action" v-if="initState === 1">
      <v-btn flat icon color="pink" title="Add To-do" @click="doAdd" v-if="renderActions">
        <v-icon>mdi-plus-box</v-icon>
      </v-btn>
      <v-btn flat icon color="teal" title="View Completed" @click="viewCompletedToDos" v-if="renderActions">
        <v-icon>mdi-archive</v-icon>
      </v-btn>
    </template>
    <div v-if="initState === 1">
      <to-do-list-completed title="Completed To-Do List" v-model="toDoListCompleted" @close="doClose"></to-do-list-completed>
      <v-card-text v-if="showAdd" key="key1">
        <v-text-field v-model="toDoName" label="Task*" data-vv-name="task" data-vv-as="Task" :error-messages="errors.collect('task')" v-validate="'required'"></v-text-field>
        <v-btn flat icon color="green" @click="addToDo(toDoName)">
          <v-icon>mdi-check</v-icon>
        </v-btn>
        <v-btn flat icon color="red" @click="doDone">
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-text>
      <v-card-text v-else-if="showEdit" key="key2">
        <v-text-field v-model="toDoName" label="Task*" data-vv-name="task" data-vv-as="Task" :error-messages="errors.collect('task')" v-validate="'required'"></v-text-field>
        <v-btn flat icon color="green" @click="editToDo(toDoName)">
          <v-icon>mdi-check</v-icon>
        </v-btn>
        <v-btn  flat icon color="red" @click="doCancel">
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text v-if="items.length === 0">
        <v-layout align-center justify-center column>
          You have not added any To-do
        </v-layout>
      </v-card-text>
      <div v-else>
        <v-list>
          <transition-group name="scale-transition" tag="div">
            <v-list-tile avatar v-for="item in items" :key="item.description" @contextmenu="renderContext($event, item)" :disabled="showAdd || showEdit">
              <v-list-tile-action>
                <v-checkbox color="green" v-model="item.completed" @change="updateToDo(item)" ></v-checkbox>
              </v-list-tile-action>
              <v-list-tile-content>
                {{item.description}}
              </v-list-tile-content>
            </v-list-tile>
          </transition-group>
        </v-list>
      </div>
    </div>
    <loader v-else :card="false" :height="150" :init="doReload" :loading="initState === 0"></loader>
    <v-menu offset-y v-model="showContextMenu" absolute :position-x="contextMenuX" :position-y="contextMenuY" :min-width="180" transition="no-transition">
      <v-list>
        <v-list-tile @click="doEdit(selectedItem)">
          <v-list-tile-action>
            <v-icon>mdi-pencil</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Edit</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="removeToDo(selectedItem)">
          <v-list-tile-action>
            <v-icon>mdi-delete</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Delete</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </widget-template>
</template>

<script>
import WidgetTemplate from '../WidgetTemplate'
import Vue from 'vue'
import http, { expandURI } from '@/utils/ajax'
import { TODO_ADD, TODO_UPDATE, TODO_REMOVE, TODO_UNDO, TODO_EDIT } from '@/store/types'
import { mapActions } from 'vuex'
import ToDoListCompleted from './ToDoListCompleted'

export default {
  data() {
    return {
      showAdd: false,
      showEdit: false,
      toDoName: '',
      toDoCompleted: false,
      selectedItem: null,
      showContextMenu: false,
      contextMenuX: 0,
      contextMenuY: 0,
      updatedItem: null,
      updatedItemIndex: null,
      toDoListCompleted: false
    }
  },
  computed: {
    items() {
      let items = []
      this.$store.state.widgets.toDoList.tasks.map((item) => {
        let userToDo = {
          id: item.id,
          description: item.description,
          completed: item.completed,
          completedDate: item.completedDate
        }
        items.push(userToDo)
      })
      return items
    },
    initState() {
      return this.$store.state.widgets.toDoList.init
    },
    renderActions() {
      if (this.showAdd || this.showEdit) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    ...mapActions([
      'initToDo'
    ]),
    doAdd() {
      this.showAdd = true
    },
    doDone() {
      this.showAdd = false
      this.toDoName = ''
      this.doReload()
    },
    doEdit(selectedItem) {
      this.showEdit = true
      this.toDoName = selectedItem.description
    },
    doCancel() {
      this.showEdit = false
      this.toDoName = ''
    },
    addToDo(taskDesc) {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.$store.state.widgets.toDoList.init === 1) {
            let userToDo = {
              description: taskDesc,
              completed: false,
              completedDate: null
            }

            this.$store.commit(TODO_ADD, userToDo)

            // Contact server to add to-do
            const apiUrl = this.$store.state.widgets.toDoList.menu.addToDo
            if (apiUrl) {
              try {
                const postData = {
                  id: 0, // dummy value
                  description: userToDo.description,
                  completed: false,
                  completedDate: null
                }
                http.post(apiUrl, postData)
              } catch (error) { }
            }
            this.toDoName = ''
            this.$validator.reset()
          } else {
            Vue.prototype.$snotify.error('You need to enable To-Do feature in Dashboard')
          }
        }
      })
    },
    updateToDo(item) {
      this.updatedItemIndex = this.items.indexOf(item)
      this.updatedItem = item
      const userToDo = {
        id: item.id,
        description: item.description,
        completed: true,
        completedDate: new Date()
      }

      this.$store.commit(TODO_UPDATE, userToDo)
      // Contact server to update to-do
      const apiUrl = this.$store.state.widgets.toDoList.menu.updateToDo
      if (apiUrl) {
        try {
          const postData = {
            id: userToDo.id,
            description: userToDo.description,
            completed: userToDo.completed,
            completedDate: userToDo.completedDate
          }
          http.put(apiUrl, postData)

          const updatedToDo = {
            id: this.updatedItem.id,
            description: this.updatedItem.description,
            completed: this.updatedItem.completed,
            completedDate: this.updatedItem.completedDate,
            updatedItemIndex: this.updatedItemIndex
          }

          this.$snotify.success('You have completed ' + updatedToDo.description, '', {
            bodyMaxLength: 30,
            timeout: 5000,
            buttons: [
              { text: 'Undo', action: (toast) => { this.undoUpdateToDo(updatedToDo); this.$snotify.remove(toast.id) }, bold: true }
            ]
          })
        } catch (error) { }
      }
    },
    removeToDo(selectedItem) {
      this.$store.commit(TODO_REMOVE, selectedItem)

      // Contact Server to remove To-Do
      const apiUrl = this.$store.state.widgets.toDoList.menu.removeToDo
      if (apiUrl) {
        try {
          const expand = {
            id: selectedItem.id
          }
          http.delete(expandURI(apiUrl, expand))
        } catch (error) { }
      }
    },
    editToDo(taskDesc) {
      this.updatedItemIndex = this.items.indexOf(this.selectedItem)
      this.updatedItem = this.selectedItem
      const userToDo = {
        id: this.selectedItem.id,
        description: taskDesc,
        completed: this.selectedItem.completed,
        completedDate: this.selectedItem.completedDate
      }

      this.$store.commit(TODO_EDIT, userToDo)
      // Contact server to update to-do
      const apiUrl = this.$store.state.widgets.toDoList.menu.updateToDo
      if (apiUrl) {
        try {
          const postData = {
            id: userToDo.id,
            description: userToDo.description,
            completed: userToDo.completed,
            completedDate: userToDo.completedDate
          }
          http.put(apiUrl, postData)
          this.toDoName = ''
          this.showEdit = false
        } catch (error) { }
      }
    },
    renderContext(e, item) {
      this.selectedItem = item
      e.preventDefault()
      this.showContextMenu = false
      this.contextMenuX = e.clientX
      this.contextMenuY = e.clientY
      this.$nextTick(() => {
        this.showContextMenu = true
      })
    },
    undoUpdateToDo(updatedItem) {
      const userToDo = {
        id: updatedItem.id,
        description: updatedItem.description,
        completed: updatedItem.completed,
        completedDate: updatedItem.completedDate,
        updatedItemIndex: updatedItem.updatedItemIndex
      }
      this.$store.commit(TODO_UNDO, userToDo)
      // Contact server to update to-do
      const apiUrl = this.$store.state.widgets.toDoList.menu.updateToDo
      if (apiUrl) {
        try {
          const postData = {
            id: userToDo.id,
            description: userToDo.description,
            completed: userToDo.completed,
            completedDate: userToDo.completedDate
          }
          http.put(apiUrl, postData)
        } catch (error) { }
      }
    },
    viewCompletedToDos() {
      this.toDoListCompleted = true
      this.$snotify.clear()
    },
    doClose() {
      this.toDoListCompleted = false
    },
    doReload() {
      this.initToDo()
    }
  },
  mounted() {
    if (this.initState !== 1) {
      this.initToDo()
    }
  },
  components: {
    ToDoListCompleted,
    WidgetTemplate
  }
}
</script>
<style lang="scss">
</style>
